import React from 'react';

import { observer } from 'mobx-react';

import FlatButton from 'bz-core-controls/controls/general/flatButton';
import { useMenuPageItem } from 'bz-core-controls/controls/general/nested-list-new/stores/menu-store';
import Popover from 'bz-core-controls/controls/modal/popover';

import { useBzPopoverStore } from 'bz-stores/mobx/popover-store';

import Alternates from './controls/alternates';
import OptionsDetailsDelete from './controls/delete';
import OptionsDetailsInput from './controls/input';
import OptionsDetailsSave from './controls/save';
import OptionsDetailsStore from './store/option-details';

export interface IOptionsPopoverProps {}

const OptionsPopover: React.FC<IOptionsPopoverProps> = observer(() => {
  const { anchorEl, isOpen, close } = useBzPopoverStore();
  return (
    <Popover open={isOpen} anchorEl={anchorEl} style={{ minWidth: 350 }} onRequestClose={close}>
      <OptionsDetails />
    </Popover>
  );
});

export interface IOptionsDetailsProps {}

const OptionsDetails: React.FC<IOptionsDetailsProps> = observer(() => {
  const { close } = useBzPopoverStore();
  const item = useMenuPageItem();

  const [details] = React.useState(new OptionsDetailsStore(item));

  return (
    <div className="options-popover grid grid-cols-[2fr,2fr,2fr,1fr,1fr] items-center gap-[5px] p-[5px]">
      <OptionsDetailsInput details={details} />
      <Alternates values={details.alts} />
      <OptionsDetailsDelete />
      <FlatButton className="col-start-3" small={true} label="Cancel" onClick={close} />
      <OptionsDetailsSave details={details} />
    </div>
  );
});

export default OptionsPopover;
